export class TaskService {
    constructor(params) {
        if(params.apiUrl === null || params.apiUrl === undefined) {

        }

        this.apiUrl = params.apiUrl;

        console.log(this.apiUrl);
    }

    getTasks(userId) {
        return fetch(`${this.apiUrl}/tasks?userId=${userId}`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }

    getProjectTasks(userId, projectId) {
        return fetch(`${this.apiUrl}/tasks?userId=${userId}&projectId=${projectId}`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }

    getTaskById(taskId, userId) {
        return fetch(`${this.apiUrl}/tasks?userId=${userId}`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }

    deleteTask(taskId, user) {
        // Default options are marked with *
        return fetch(`${this.apiUrl}/tasks/${taskId}?userId=${user.id}`, {
            // body: JSON.stringify(params), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then(response => response.json()) // parses response to JSON
    }

    postTask(task, user, projectId = null) {
        let params = {
            task: {
                name: "...",
                projectId: projectId,
                tags: [{id: 3, name: 'today', code: 'TODAY'}]
            },
            user: {
                id: user.id
            }
        };

        // Default options are marked with *
        return fetch(`${this.apiUrl}/tasks/`, {
            body: JSON.stringify(params), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then(response => response.json()) // parses response to JSON
    }

    putTask(task, user) {
        let params = {
            task: task,
            user: {
                id: user.id
            }
        };

        console.log(params);

        // Default options are marked with *
        return fetch(`${this.apiUrl}/tasks/`, {
            body: JSON.stringify(params), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then(response => response.json()) // parses response to JSON
    }
}


// WEBPACK FOOTER //
// src/services/task.service.js